import { requestPost } from "../../../Helpers";


export const updateQuantityOrderItem = (orderProductId, quantity, category_id, orderId) => {

    const formData = new FormData();
    formData.append("uuid", orderProductId);
    formData.append("quantity", quantity);
    formData.append("category_id", category_id);
    formData.append("order_id", orderId);

    return requestPost(`update_order_items/`, formData)
            .then((data) => {
                if ( typeof(data) == "object" ) {
                    return data
                } else {
                    return false
                }
            })
            .catch( (e) => {
                console.log(e)
            })
}
